import {
  CriteriaWithPagination,
  EuiButtonIcon,
  EuiFlexGroup,
  EuiFlexItem,
  EuiLink,
  EuiTableSelectionType,
} from "@elastic/eui";
import {
  Anchor,
  Box,
  Button,
  Flex,
  Grid,
  Input,
  LoadingOverlay,
  Text,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconDownload, IconSearch } from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  isNullOrUndefined,
  isNullOrUndefinedArry,
} from "../../../_base/extension/StringExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { ParamSearchBase } from "../../../_base/model/_base/ParamSearchBase";
import AppAction from "../../../common/AppAction";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { BASE_API_URL } from "../../../config";
import { _localization } from "../../../config/location";
import { Khung } from "../../../model/CategoryProductFrame";
import { MessageResponse } from "../../../model/MessageResponse";
import ModalUpdateExcelProduct from "../ProductList/ModalUpdate/ModalUpdateExcelProduct";
import CreateView from "./CreateView";
import DeleteView from "./DeleteView";
import EditView from "./EditView";

// New interface matching the provided object

export default function CollectionFrame() {
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [datas, setDatas] = useState<Khung[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [total, setTotal] = useState(0);
  const [paramSearch, setParamSearch] = useState<ParamSearchBase>();
  const [isSelectedItem, setSelectedItems] = useState<any[]>([]);
  const [selectedOptions, setSelected] = useState();
  const navigate = useNavigate();
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;

  const vitrimap = new Map([
    ["bottom", "Bên dưới "],
    ["left", "Bên trái"],
    ["right", "Bên phải"],
  ]);

  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: {
      KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
      ItemCode: _searchJson && checkedPinSearch ? _searchJson?.ItemCode : "",
    },
  });

  // Helper function để lấy các ID được chọn
  const getSelectedIds = (): number[] => {
    return Object.keys(rowSelection)
      .filter((key) => rowSelection[key])
      .map((key) => datas[parseInt(key)].id);
  };

  const columns = React.useMemo<MRT_ColumnDef<Khung>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 100,
      },
      {
        accessorKey: "id",
        header: "ID",
        size: 100,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenKhung",
        header: "Tên bộ sưu tập",
        size: 300,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "classCss",
        header: "Class CSS",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      // {
      //   accessorKey: "link",
      //   header: "Link",
      //   Cell: ({ row }) => {
      //     const item = row.original.link;
      //     return (
      //       <>
      //         {item && item.trim() !== "" ? (
      //           <Anchor
      //             href={`${hacomUrl}/collection/${item}`}
      //             target="_blank"
      //             rel="noopener noreferrer"
      //             style={{ color: "#1976d2", cursor: "pointer" }}
      //           >
      //             Xem trang
      //           </Anchor>
      //         ) : (
      //           <Text c="dimmed" fs="italic">
      //             Không có link
      //           </Text>
      //         )}
      //       </>
      //     );
      //   },
      // },
      {
        accessorKey: "urlAnh",
        header: "Ảnh khung",
        Cell: ({ row }) => {
          const item = row.original.urlAnh;
          return (
            <>
              {item && String(item).trim() !== "" ? (
                <Anchor
                  href={String(item)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#1976d2", cursor: "pointer" }}
                >
                  Xem ảnh
                </Anchor>
              ) : (
                <Text c="dimmed" fs="italic">
                  Không có ảnh
                </Text>
              )}
            </>
          );
        },
      },
      {
        accessorKey: "viTriKhung",
        header: "Vị trí khung",
        Cell: ({ renderedCellValue }) => {
          return (
            <>{vitrimap.get(String(renderedCellValue)) || renderedCellValue}</>
          );
        },
      },
      {
        accessorKey: "maSanPham",
        header: "Số sản phẩm",
        width: "15%",
        Cell: ({ row }) => {
          const item = row.original;
          const raw = item?.maSanPham;
          const count = Array.isArray(raw)
            ? raw.length
            : typeof raw === "string"
            ? raw
                .split(",")
                .map((s) => s.trim())
                .filter((s) => s).length
            : 0;
          return (
            <Text>
              {count} sp (
              <EuiLink
                target="_blank"
                onClick={() =>
                  navigate("/product-manager/collection-frame/product", {
                    state: { id: item.id },
                  })
                }
              >
                Xem sản phẩm
              </EuiLink>
              )
            </Text>
          );
        },
      },
      // {
      //   accessorKey: "visit",
      //   header: "Lượt xem",
      //   render: (item: any) => <Text>{item || 0}</Text>,
      //   width: "10%",
      // },
      {
        accessorKey: "createdDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        sortingFn: (a, b) => {
          const dateA = new Date(a.original.createdDate || 0);
          const dateB = new Date(b.original.createdDate || 0);
          return dateA.getTime() - dateB.getTime();
        },
      },
      {
        accessorKey: "actions",
        header: "Thao tác",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        size: 100,
        Cell: ({ renderedCellValue, row }) => (
          <EuiFlexGroup
            responsive={true}
            wrap={false}
            gutterSize="s"
            alignItems="center"
          >
            <EuiFlexItem grow={false}>
              <EuiButtonIcon
                iconType="documentEdit"
                aria-label="Dashboard"
                color="success"
                onClick={() => editItem(row.original.id)}
              />
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
              <EuiButtonIcon
                iconType="trash"
                color="danger"
                onClick={() => deleteItem([row.original.id])}
              />
            </EuiFlexItem>
          </EuiFlexGroup>
        ),
      },
    ],
    []
  );

  const onTableChange = async ({
    page: { index, size },
  }: CriteriaWithPagination<any>) => {
    setPagination({
      ...pagination,
      pageIndex: index,
      pageSize: size,
    });
  };

  // console.log("datas", datas);

  const onSelectionChange = (selectedItems: any[]) => {
    setSelectedItems(selectedItems);
  };

  const selection: EuiTableSelectionType<any> = {
    selectable: (user: any) => true,
    selectableMessage: (selectable: boolean) =>
      !selectable ? "User is currently offline" : "",
    onSelectionChange,
  };

  const onChange = (selectedOptions: any) => {
    setSelected(selectedOptions);
    if (!isNullOrUndefinedArry(selectedOptions)) {
      const value = selectedOptions[0].value;
      if (!isNullOrUndefined(value))
        setParamSearch({ ...paramSearch, inActive: value });
    } else setParamSearch({ ...paramSearch, inActive: undefined });
  };

  const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
    const key = event.target.value;
    if (!isNullOrUndefined(key))
      setParamSearch({ ...paramSearch, keyWord: key });
  };

  const openModal = () =>
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Thêm bộ sưu tập mới</Title>
          </div>
        </>
      ),
      children: (
        <CreateView
          onSearch={() =>
            fetchDataCollectionList(
              pagination.pageIndex,
              pagination.pageSize,
              paramSearch?.keyWord,
              paramSearch?.inActive
            )
          }
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });

  const openModalEdit = () => {
    if (
      isSelectedItem &&
      (isSelectedItem.length < 1 || isSelectedItem.length > 1)
    )
      NotificationExtension.Warn(
        "Xin vui lòng chọn 1 danh mục khách hàng để chỉnh sửa !"
      );
    else {
      editItem(isSelectedItem[0].id);
    }
  };

  const openModalDelete = () => {
    // Lấy các ID của row được chọn
    const selectedIds = getSelectedIds();

    if (selectedIds.length === 0) {
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu để xóa!");
      return;
    }

    deleteItem(selectedIds);
  };

  function deleteItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa bộ sưu tập</Title>
        </>
      ),
      children: (
        <DeleteView
          onSearch={() =>
            fetchDataCollectionList(
              pagination.pageIndex,
              pagination.pageSize,
              paramSearch?.keyWord,
              paramSearch?.inActive
            )
          }
          idItem={idItem}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function editItem(id: number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa bộ sưu tập!</Title>
        </>
      ),

      children: (
        <EditView
          id={id}
          onSearch={() =>
            fetchDataCollectionList(
              pagination.pageIndex,
              pagination.pageSize,
              paramSearch?.keyWord,
              paramSearch?.inActive
            )
          }
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  }

  const fetchDataCollectionList = async (
    index: number,
    size?: number,
    keyWord?: string,
    inActive?: boolean
  ) => {
    setLoading(true);
    setDatas([]);
    setError(undefined);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    try {
      let urlSearch = `/TblKhung/get-list?Skip=${
        index * (size ?? 0)
      }&Take=${size}`;
      if (formSeachInput.getValues().KeySearch)
        urlSearch += `&KeySearch=${formSeachInput.getValues().KeySearch}`;
      if (formSeachInput.getValues().ItemCode)
        urlSearch += `&ItemCode=${formSeachInput.getValues().ItemCode}`;
      if (!isNullOrUndefined(inActive))
        urlSearch = urlSearch + `&Active=` + inActive;
      let callapi = await repository.get<MessageResponse<Khung[]>>(urlSearch);
      if (isNullOrUndefined(callapi) || isNullOrUndefinedArry(callapi?.data)) {
        setRowCount(0);
      } else {
        setDatas(callapi?.data ?? []);
        setPagination({
          ...pagination,
        });
        setRowCount(callapi?.totalCount ?? 0);
      }
      return callapi?.data;
    } catch (error: any) {
      setError("Có lỗi xảy ra khi tải dữ liệu !");
      return null;
    } finally {
      setLoading(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...formSeachInput.getValues(),
          pageSize: pagination.pageSize,
          pageIndex: pagination.pageIndex,
        })
      );
    }
  };

  const fetchData = async () => {
    await fetchDataCollectionList(
      pagination.pageIndex,
      pagination.pageSize,
      paramSearch?.keyWord,
      paramSearch?.inActive
    );
  };
  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    // Reset row selection khi chuyển trang hoặc data thay đổi
    setRowSelection({});
  }, [datas]);

  const table = useMantineReactTable({
    columns,
    data: datas || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    localization: _localization,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "STT", "id"],
        right: ["status", "actions"],
      },
      density: "xs",
    },
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    state: {
      pagination,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyCellProps: () => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    positionToolbarAlertBanner: "bottom",
  });

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  // useEffect(() => {
  //   if (_searchJson) {
  //     setPagination({
  //       pageIndex: _searchJson.pageIndex,
  //       pageSize: _searchJson.pageSize,
  //     });
  //   }
  // }, []);

  const exportExcel = async () => {
    open(); // Hiển thị loading
    try {
      // Lấy các ID của row được chọn
      const selectedIds = getSelectedIds();

      // Khởi tạo URL với các tham số phân trang
      const params = new URLSearchParams();

      // // Thêm thông tin phân trang
      // params.append(
      //   "Skip",
      //   (pagination.pageIndex * pagination.pageSize).toString()
      // );
      // params.append("Take", pagination.pageSize.toString());

      // Lấy giá trị từ form và thêm vào params nếu có giá trị
      const { KeySearch, ItemCode } = formSeachInput.getValues();
      if (KeySearch) params.append("KeySearch", KeySearch);
      if (ItemCode) params.append("ItemCode", ItemCode);

      // Thêm các ID được chọn vào params nếu có
      if (selectedIds.length > 0) {
        selectedIds.forEach((id) => params.append("Ids", id.toString()));
      }
      // Xây dựng URL API cuối cùng
      const baseUrl = `/ExportExcel/export-bao-cao-khung-san-pham?${params.toString()}`;

      const _url = BASE_API_URL + baseUrl;
      const fullUrl = new URL(_url);
      const token = localStorage.getItem("token");

      // Gọi API
      const response = await fetch(fullUrl.toString(), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
          "Content-Type": "application/vnd.ms-excel",
        },
      });
      // Kiểm tra trạng thái HTTP
      if (!response.ok) {
        const errorResponse = await response.json(); // Parse lỗi từ API
        const errorMessage =
          errorResponse?.message || "Đã xảy ra lỗi khi xuất dữ liệu!";
        throw new Error(errorMessage); // Ném lỗi để xử lý trong `catch`
      }

      // Xử lý file Excel
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const filename = "khung-san-pham.xlsx"; // Tên mặc định nếu không có header
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error: any) {
      console.error("Error:", error);
      // Hiển thị thông báo lỗi
      NotificationExtension.Fails(
        error.message || "Đã xảy ra lỗi không xác định!"
      );
    } finally {
      close(); // Đóng loading
    }
  };
  // hàm mở modal để cập nhật file excel
  const openModalupdateExel = () => {
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Tạo sản phẩm vào bộ sưu tập bằng Excel</Title>
          </div>
        </>
      ),
      children: <ModalUpdateExcelProduct location={location} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  return (
    <>
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadCrumb />
        <Flex gap={"xs"} align={"center"}>
          <AppAction
            openModal={openModal}
            openModalDelete={openModalDelete}
            openModalCreate={openModal}
            openModalupdateExel={openModalupdateExel}
          ></AppAction>
          <Button
            leftSection={<IconDownload size={14} />}
            onClick={() => exportExcel()}
          >
            Export Excel
          </Button>
        </Flex>
      </Flex>

      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          // marginTop: "10px",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Grid style={{ width: "100%" }} mt={10}>
          <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Từ khoá"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("KeySearch")}
              {...formSeachInput.getInputProps("KeySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Mã sản phẩm"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("ItemCode")}
              {...formSeachInput.getInputProps("ItemCode")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>{" "}
          </Grid.Col>
        </Grid>
      </Box>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
}
